import { System } from './../../shared-components/System';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { LoginSettings } from './LoginSetting.model';
import { User } from '../../shared-components/user/user.model';
import { AccessHistory } from '../../classroom360/system-settings/system-settings-v9/upgrade-access-history/access-history-sub-tab/access-history-sub-tab.model';
import { OIDCSettings } from './oidcSetting.model';

@Injectable()
export class LoginService {

    public LoginSettings: LoginSettings;
    public OidcSettings: OIDCSettings;
    public googleError = '';
    public hasSignedIntoGoogle = false;
    public hasSignedIntoTylerId = false;
    public isLogin: boolean;
    public redirectingToClassic: boolean;

    private _IntegrateWithTylerU: boolean;
    get IntegrateWithTylerU(): boolean {
        return this._IntegrateWithTylerU;
    }
    set IntegrateWithTylerU(value: boolean) {
        this._IntegrateWithTylerU = value;
        this.observableIntegrateWithTylerU.next(this._IntegrateWithTylerU);
    }

    observableLogin = new Subject<boolean>();
    observableLoginStream$ = this.observableLogin.asObservable();

    observableLoginError = new Subject<Error>();
    observableLoginErrorStream$ = this.observableLoginError.asObservable();

    observableIntegrateWithTylerU = new Subject<boolean>();
    observableIntegrateWithTylerUStream$ = this.observableIntegrateWithTylerU.asObservable();
    public resetLanguage = new EventEmitter<boolean>();
    constructor(private http: HttpClient) {
    }

    getDistrictSettings(): Observable<LoginSettings> {
        return this.http.get<LoginSettings>(System.apiURL.Student + 'GetLoginDistrictSettings');
    }

    getOIDCSettings(): Observable<OIDCSettings> {
        return this.http.get<OIDCSettings>(System.apiURL.Student + 'getOIDCSettings');
    }

    logonTID(idToken: string, userType: number): Observable<any> {
        const data = 'grant_type=tyler_oAuth' +
            '&idToken=' + encodeURIComponent(idToken) +
            '&userType=' + userType;
        return this.http.post(System.tokenURL, data);
    }

    getApplicationVersion(): Observable<string> {
        return this.http.get<string>(System.apiURL.Student + 'GetApplicationVersion');
    }

    saveDistrictSettings(schoolId: number, yearId: number, settings: LoginSettings): Observable<boolean> {
        const queryString = '?schoolId=' + schoolId +
            '&yearId=' + yearId;
        return this.http.post<boolean>(System.apiURL.Student + 'SaveLoginDistrictSettings' + queryString, settings);
    }

    logon(userName: string, password: string, userType = 1): Observable<any> {
        const data = 'grant_type=password&username=' + encodeURIComponent(userName) + '&password=' + encodeURIComponent(password) + '&scope=' + userType;
        return this.http.post(System.tokenURL, data);
    }

    logonGoogle(idToken: string, userType: number, grantType: string): Observable<any> {
        const data = 'grant_type=' + grantType +
            '&idToken=' + encodeURIComponent(idToken) +
            '&userType=' + userType;
        return this.http.post(System.tokenURL, data);
    }

    getUser(): Observable<User> {
        return this.http.get<User>(System.apiURL.Student + 'GetUser');
    }

    getForgetPasswordDetail(params: string[]): Observable<any> {
        return this.http.post(System.apiURL.Student + 'GetForgetPasswordDetail', params);
    }

    getRegisterParent(id: number): Observable<any> {
        return this.http.get(System.apiURL.Student + 'GetRegisterParent?id=' + id);
    }

    getRegisterParentInfo(parentEmail: string, verificationCode: string): Observable<any> {
        let queryString = '';
        queryString += '?parentEmail=' + encodeURIComponent(parentEmail) +
            '&verificationCode=' + verificationCode;
        return this.http.get(System.apiURL.Student + 'GetRegisterParentInfo' + queryString);
    }


    getUserDefaultSchoolYearIsBlocked(): Observable<any> {
        return this.http.get(System.apiURL.Student + 'GetUserDefaultSchoolYearIsBlocked');
    }

    saveUserLoginInfo(userId: number, userType: number, height: number, width: number, loginAction: number, loginName: string): void {
        this.getClientInformation().subscribe((clientInfo) => {
            const userAgent = window.navigator.userAgent;

            let queryString = '';
            queryString += '?userId=' + userId +
                '&userType=' + userType +
                '&clientIP=' + clientInfo[0] +
                '&clientMachineName=' + clientInfo[1] +
                '&serverIP=' + clientInfo[2] +
                '&screenHeight=' + height +
                '&screenWidth=' + width +
                '&loginAction=' + loginAction +
                '&loginName=' + loginName +
                '&userAgent=' + userAgent;

            this.http.get(System.apiURL.Student + 'SaveUserLoginInfo' + queryString).subscribe();
        });
    }

    getClientInformation(): Observable<string[]> {
        return this.http.get<string[]>(System.apiURL.Student + 'GetClientInformation');
    }

    sendForgetUserNameEmail(firstName: string, lastName: string, emailAddress: string, userType: number): Observable<string> {
        let queryString = '';
        queryString += '?firstName=' + firstName +
            '&lastName=' + lastName +
            '&emailAddress=' + emailAddress +
            '&userType=' + userType;
        return this.http.get<string>(System.apiURL.Student + 'SendForgetUserNameEmail' + queryString);
    }

    saveForgetPassword(password: string, area: string, forgetPasswordParams: any): Observable<any> {
        password = encodeURIComponent(password);
        return this.http.post(System.apiURL.Student + `SaveForgetPassword?password=${password}&area=${area}`, forgetPasswordParams, { observe: 'response' });
    }

    sendForgetPasswordEmail(userName: string, userType: number, setPassword: boolean): Observable<string> {
        let queryString = '';
        queryString += '?userName=' + userName +
            '&userType=' + userType +
            '&setPassword=' + setPassword;
        return this.http.get<string>(System.apiURL.Student + 'SendForgetPasswordEmail' + queryString);
    }

    getStaffIdByUserId(): Observable<number> {
        return this.http.get<number>(System.apiURL.Student + 'GetStaffIdByUserId');
    }

    saveTylerAccessHistory(accessHistory: AccessHistory) {
        return this.http.post(System.apiURL.Classroom + 'SaveTylerAccessHistory', accessHistory);
    }

}
